export default __webpack_public_path__ + "static/media/avatar-8.8249b6d0.jpg";